import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import axiosInstance from "../utils/axios";

export const useAxios = () => {
  const [options, setOptions] = useState({});
  const [response, setResponse] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const cancelSource = useRef(null);

  const fetchData = useCallback((opt) => {
    setOptions(opt);
    cancelSource.current = axios.CancelToken.source();
    setIsLoading(true);
  }, []);

  const clearState = useCallback(() => {
    setResponse(undefined);
    setError(undefined);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!options.url) {
      setIsLoading(false);
      return;
    }

    if (!cancelSource.current) {
      return;
    }

    if (!isLoading) {
      return;
    }

    const { responseCallback, errorCallback, cancelCallback, ...other } =
      options;

    axiosInstance({
      ...other,
      cancelToken: cancelSource.current.token,
    })
      .then((res) => {
        const { data } = res;
        setError(undefined);
        setResponse(data);
        if (responseCallback) responseCallback(data);
      })
      .catch((err) => {
        setResponse(undefined);
        if (axios.isCancel(err)) {
          if (cancelCallback) cancelCallback();
        } else {
          const res = err.response;
          setError(res);
          if (errorCallback) errorCallback(res);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => {
      if (cancelSource.current) cancelSource.current.cancel();
    };
  }, [options, isLoading]);

  return [{ response, isLoading, error }, fetchData, clearState];
};
